import { useState } from 'react'

import { withStyles, WithStyles } from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { RootState } from 'store/store'

import locationPickerTreeActions from '../../../../../../../components/_shared/customTree/services/locationPickerTree-actions'
import {
  getAssignedLocationsLabel,
  LocationFilter,
  LocationTreeNode,
  prepareLocationFiltersForDevice,
} from '../../../../../services/locationPicker-service'
import AssignLocationModal from './AssignLocationModal'
import styles from './style'

type OwnProps = {
  error?: boolean
  locationFilter: LocationFilter
  onLocationFilterChange: (filter: LocationFilter) => void
}

type LocationChipProps = OwnProps &
  ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps> &
  WithStyles<typeof styles>

const LocationChip = ({
  classes,
  error = false,
  locationFilter,
  onLocationFilterChange,
  nodes,
  isAllSelected,
  treeCopy,
  loadNodesSucceeded,
}: LocationChipProps) => {
  const [open, setOpen] = useState(false)

  const assignedLocationsLabel = getAssignedLocationsLabel(
    locationFilter,
    isAllSelected
  )

  const handleClose = () => {
    if (treeCopy) {
      loadNodesSucceeded(treeCopy, locationFilter.selectedBuildings)
    }
    setOpen(false)
  }

  const onApply = () => {
    const params = prepareLocationFiltersForDevice(nodes)
    onLocationFilterChange({
      selectedName: params.selectedName,
      selectedBuildings: isAllSelected ? null : params.selectedBuildings,
    })
    setOpen(false)
  }

  if (!nodes.length) {
    return null
  }

  return (
    <>
      <TextField
        className={classes.locationField}
        label="Location"
        placeholder="Select locations"
        variant="outlined"
        margin="normal"
        fullWidth
        value={assignedLocationsLabel}
        error={error}
        onClick={() => setOpen(true)}
        InputProps={{
          readOnly: true,
          classes: { input: classes.locationInput },
        }}
        InputLabelProps={{ shrink: true }}
      />
      <AssignLocationModal
        isOpen={open}
        modalTitle="Select locations"
        actionLabel="Apply"
        onApply={onApply}
        onClose={handleClose}
      />
    </>
  )
}

const mapStateToProps = (state: RootState) => ({
  nodes: state.locationPickerTreeReducer.nodes,
  isAllSelected: state.locationPickerTreeReducer.isAllSelected,
  treeCopy: state.locationPickerTreeReducer.treeCopy,
})

const mapDispatchToProps = (dispatch: Dispatch) => ({
  loadNodesSucceeded: (
    treeRoot: LocationTreeNode,
    allowedLocationIds: number[] | null
  ) =>
    dispatch(
      locationPickerTreeActions.loadNodesSucceeded(treeRoot, allowedLocationIds)
    ),
  resetTreeState: () => dispatch(locationPickerTreeActions.resetTreeState()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(LocationChip))
